/**
 * Session persistence helpers. Single source of truth for the localStorage
 * key name and the read/write pattern — used by AuthContext and main.jsx.
 *
 * Stored shape: { token, user, client }
 * Cleared on logout or when JSON parsing fails.
 */
export const SESSION_KEY = "prism:session";

export function loadSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.token) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveSession(session) {
  if (!session) {
    localStorage.removeItem(SESSION_KEY);
    return;
  }
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
}
